module.exports = __webpack_public_path__ + "static/media/recorrido10k.7250a98a.webp";